<template>
  <div>
    <div class="secondary-content">
      <div class="left">
        <div class="results-table">
          <div v-for="row in tableRows" class="row">
            <div class="cell" v-for="cell in row" :class="cell.classObj">
              <span>{{cell.text}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  import {
    CSS_CLASS_NAME_RESULTS_QUESTION_ROW_CELL, CSS_CLASS_NAME_RESULTS_QUESTION_SCORE
  } from '../../services/constants'

  const cellFactory = (text, classStr) => {
    const obj = {
      text,
      classObj: null,
    }
    if (classStr) {
      obj.classObj = {
        [classStr]: true
      }
    }
    return obj
  }

  export default {
    name: 'ResultsSecondary',
    props: {
      index: {
        type: Number,
        default: -1,
      },
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters([]),
      studyResultsState() {
        let st = null
        switch (this.index) {
          case 1:
            st = this.$store.state.studyResultsModule.studyResultsAgeState
            break
          case 2:
            st = this.$store.state.studyResultsModule.studyResultsGenderState
            break
          case 3:
            st = this.$store.state.studyResultsModule.studyResultsPrelimState
            break
          case 4:
            st = this.$store.state.studyResultsModule.studyResults2MarketSegmentsState
            break
          case 5:
            st = this.$store.state.studyResultsModule.studyResults3MarketSegmentsState
            break
          default:
            break
        }
        return st
      },
      studyResultsOverallState() {
        return this.$store.state.studyResultsModule.studyResultsState.data
      },
      results() {
        if (this.studyResultsState) {
          return this.studyResultsState.data
        }
        return null
      },
      segments() {
        if (this.results) {
          return this.results.segments
        }
        return []
      },
      tableRows() {
        if (this.segments && this.studyResultsOverallState) {
          let row1 = [cellFactory(''), cellFactory('Overall', CSS_CLASS_NAME_RESULTS_QUESTION_SCORE)]
          this.segments.forEach(segment => {
            row1.push(cellFactory(`${segment.label} (${segment.completed})`, CSS_CLASS_NAME_RESULTS_QUESTION_SCORE))
          })
          let row2 = [
            cellFactory('Additive Constant'),
            cellFactory(this.formatNumbers(this.studyResultsOverallState.additiveConstant), CSS_CLASS_NAME_RESULTS_QUESTION_SCORE)
          ]
          this.segments.forEach(segment => {
            row2.push(cellFactory(this.formatNumbers(segment.additiveConstant), CSS_CLASS_NAME_RESULTS_QUESTION_SCORE))
          })
          const table = [row1, row2]
          if (this.segments.length > 0) {
            this.segments[0].questions.forEach((question, qIdx) => {
              let newQuestionRow = [
                cellFactory(question.question, CSS_CLASS_NAME_RESULTS_QUESTION_ROW_CELL),
                cellFactory('', CSS_CLASS_NAME_RESULTS_QUESTION_ROW_CELL)
              ]
              this.segments.forEach(() => {
                newQuestionRow.push(cellFactory('', CSS_CLASS_NAME_RESULTS_QUESTION_ROW_CELL))
              })
              table.push(newQuestionRow)
              question.answers.forEach((answer, aIdx) => {
                let newAnswerRow = [cellFactory(answer.answer)]
                newAnswerRow.push(cellFactory(this.formatNumbers(this.studyResultsOverallState.questions[qIdx].answers[aIdx].score), CSS_CLASS_NAME_RESULTS_QUESTION_SCORE))
                this.segments.forEach((segment) => {
                  newAnswerRow.push(cellFactory(this.formatNumbers(segment.questions[qIdx].answers[aIdx].score), CSS_CLASS_NAME_RESULTS_QUESTION_SCORE))
                })
                table.push(newAnswerRow)
              })
            })
          }
          return table
        }
        return []
      },
      wordsState() {
        let st = []
        switch (this.index) {
          case 1:
            st = this.$store.state.studyResultsModule.studyResultsAgeWordsState
            break
          case 2:
            st = this.$store.state.studyResultsModule.studyResultsGenderWordsState
            break
          case 3:
            st = this.$store.state.studyResultsModule.studyResultsPrelimWordsState
            break
          case 4:
            st = this.$store.state.studyResultsModule.studyResults2MarketSegmentsWordsState
            break
          case 5:
            st = this.$store.state.studyResultsModule.studyResults3MarketSegmentsState
            break
          default:
            break
        }
        return st
      },

    },
    methods: {
      formatNumbers(num){
        return Math.round(num)
      },
    },
    created() {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .secondary-content {
    padding: 1%;
    display: flex;
    font-size: 14px;
    color: $cyan-1;

    > .left {
      width: 100%;

      .results-table {

        .row {
          display: flex;

          .cell {
            flex-grow: 1;
            flex-basis: 1px;
            display: flex;

            &:first-child {
              flex-grow: 2;

              &.question-row-cell {
                border-top: solid 1px $gray-2;
              }
            }

            &.question-row-cell {
              padding: 10px 0 10px 0;
              margin: 10px 0 0 0;
            }

            &.question-score{
              display: block;
              text-align: right;
            }

          }

          &:first-child {
            border-bottom: solid 1px $gray-2;
            padding: 10px 0;
            margin: 0 0 10px 0;

            .cell {
              &:first-child {
                border: none;
              }
            }
          }
        }
      }
    }

    > .right {
      width: 29%;

      > div {
        padding: 10px 0 10px 14px;

        .words {
          border-bottom: solid 1px $gray-2;
          margin: 0 0 15px 0;

          .cloud {
            min-height: 150px;
          }
        }
      }
    }
  }
</style>
